import React from 'react'
import { ActionButton } from './ActionButton'

function CrossAccentButton(props) {
  return <ActionButton backgroundColor="#d0021b" iconType="iconClose" {...props} />
}

export { CrossAccentButton }
